"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gen_run_enemyTurn = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var physicsTickManager_sidecar_1 = require("../to-engine/physicsTickManager-sidecar");
var minigolfGameState_1 = require("./minigolfGameState");
var minigolfGameState_sidecar_1 = require("./minigolfGameState-sidecar");
var minigolfMainGameGenerator_sidecar_1 = require("./minigolfMainGameGenerator-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var minigolfCreaturesData_sidecar_1 = require("../entities/minigolfCreaturesData-sidecar");
function gen_run_enemyTurn() {
    var maxTime, currentPuck, creatures, _loop_1, i, state_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                minigolfGameState_sidecar_1.minigolfGameState.get().state = minigolfGameState_1.MinigolfGameStates.enemyTurn;
                physicsTickManager_sidecar_1.physicsTickManager.setIsRunning(true);
                if (minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.isExitToLevelGenSignaled()) {
                    return [2 /*return*/, 0];
                }
                // let creatures = minigolfCreatures.getAll()
                minigolfGameState_sidecar_1.minigolfGameState.get().playerState.gameStateString = 'Enemy turn';
                maxTime = minigolfDefs_sidecar_1.minigolfDefs.maxEnemyTurnTime;
                currentPuck = minigolfGameState_sidecar_1.minigolfGameState.getCurrentPlayer();
                if (minigolfGameState_sidecar_1.minigolfGameState.get().playerState.dungeonLevel > 0) {
                    // Eat food
                    if (currentPuck && !minigolfGameState_sidecar_1.minigolfGameState.get().playerState.didWin) {
                        if (minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food <= 0) {
                            minigolfCreatures_sidecar_1.minigolfCreatures.hurt(currentPuck, 1, 'hunger', true);
                            // minigolfGameState.get().playerState.health -= 1
                            // minigolfGameState.get().playerState.lastDamage = 'hunger'
                        }
                        else {
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.food -= 1;
                        }
                    }
                }
                creatures = __spreadArray([], __read(minigolfCreatures_sidecar_1.minigolfCreatures.getAll()));
                _loop_1 = function (i) {
                    var creature, doPause, stats, web, entitys, target;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                creature = creatures[i];
                                if (creature.isDead || creature.state.health <= 0 || creature.isDead) {
                                    return [2 /*return*/, "continue"];
                                }
                                if (!creature.data.ai) {
                                    return [2 /*return*/, "continue"];
                                }
                                if (creature.data.isPuck) {
                                    return [2 /*return*/, "continue"];
                                }
                                maxTime -= common_sidecar_1.common.getUpdateDelta();
                                if (maxTime <= 0) {
                                    return [2 /*return*/, { value: 0 }];
                                }
                                doPause = false;
                                stats = creature.data;
                                if (!minigolfDefs_sidecar_1.minigolfDefs.debug_freezeEnemies) {
                                    if (stats.ai === 'random') {
                                        minigolfCreatures_sidecar_1.minigolfCreatures.flingCreatureRandomly(creature);
                                        doPause = true;
                                    }
                                    if (stats.ai === 'chase-player') {
                                        minigolfCreatures_sidecar_1.minigolfCreatures.flingCreatureTowardsPlayer(creature);
                                        doPause = true;
                                    }
                                    if (stats.ai === 'spider') {
                                        web = minigolfCreatures_sidecar_1.minigolfCreatures.createNearby(creature, minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.bonusWeb);
                                        if (web) {
                                            minigolfCreatures_sidecar_1.minigolfCreatures.flingCreatureRandomly(web, 0.1);
                                        }
                                        doPause = true;
                                    }
                                    if (stats.ai === 'chase-random-entity') {
                                        entitys = minigolfCreatures_sidecar_1.minigolfCreatures
                                            .getAll()
                                            .filter(function (c) { return c.data.isEnemy || c.data.isPuck; })
                                            .filter(function (c) { return !c.isDead && c !== creature; });
                                        if (entitys.length > 0) {
                                            target = rando_sidecar_1.rando.sample(entitys);
                                            minigolfCreatures_sidecar_1.minigolfCreatures.flingCreatureTowardsEntity(creature, target);
                                        }
                                        else {
                                            minigolfCreatures_sidecar_1.minigolfCreatures.flingCreatureRandomly(creature);
                                        }
                                        doPause = true;
                                    }
                                }
                                if (!(doPause && !minigolfDefs_sidecar_1.minigolfDefs.debug_instantEnemyFling)) return [3 /*break*/, 2];
                                return [4 /*yield*/, 0.25];
                            case 1:
                                _b.sent();
                                minigolfGameState_sidecar_1.minigolfGameState.get().playerState.gameStateString += '.';
                                _b.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                };
                i = 0;
                _a.label = 1;
            case 1:
                if (!(i < creatures.length)) return [3 /*break*/, 4];
                return [5 /*yield**/, _loop_1(i)];
            case 2:
                state_1 = _a.sent();
                if (typeof state_1 === "object")
                    return [2 /*return*/, state_1.value];
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, 0];
        }
    });
}
exports.gen_run_enemyTurn = gen_run_enemyTurn;
